import { useState, useEffect, useRef } from "react";

// Scroll-linked fade-back (pruning) for elements scrolled past
export function usePruning() {
  const ref = useRef(null);
  const [opacity, setOpacity] = useState(1);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const viewH = window.innerHeight;
      if (rect.bottom < viewH * 0.15) {
        // Element mostly above viewport — prune it
        const fade = Math.max(0.2, rect.bottom / (viewH * 0.15));
        setOpacity(fade);
      } else {
        setOpacity(1);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return [ref, opacity];
}
